import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { MenuBarPermission } from "../Types/NewPermission/MenuBarPermission";
import { getAllNewPermissionsThunk } from "../Thunks/NewPermissionThunks";

interface NewPermissionSliceState {
  loadingPermission: boolean;
  permissions: MenuBarPermission[];
  errorPermission: string | null;
}

const initialState: NewPermissionSliceState = {
  loadingPermission: false,
  permissions: [],
  errorPermission: '',

}

const newPermissionSlice = createSlice({
  name: 'newPermission',
  initialState,
  reducers: {
  },
  extraReducers(builder) {
    builder.addCase(getAllNewPermissionsThunk.rejected, (state, action) => {
      state.loadingPermission = false;
      state.errorPermission = action.error.message!;
    })
      .addCase(getAllNewPermissionsThunk.pending, state => {
        state.loadingPermission = true;
        state.errorPermission = null;
      })
      .addCase(getAllNewPermissionsThunk.fulfilled, (state, action: PayloadAction<MenuBarPermission[]>) => {
        state.loadingPermission = false;

        state.permissions = action.payload;


      })
  }
})


export const { } = newPermissionSlice.actions
export default newPermissionSlice.reducer